import { queryOptions } from '@tanstack/react-query';

import type {
  BookingGroupSchedulesQueryParams,
  BookingGroupSchedulesResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingGroupScheduleKeys = {
  all: () => ['bookingGroupSchedules'] as const,
  list: (props: BookingGroupSchedulesQueryParams) =>
    [...bookingGroupScheduleKeys.all(), 'list', props.url] as const,
};

export const bookingGroupScheduleQueries = {
  list: (props: BookingGroupSchedulesQueryParams) =>
    queryOptions({
      queryKey: bookingGroupScheduleKeys.list(props),
      queryFn: () =>
        HttpClient.request<BookingGroupSchedulesResponse>({
          method: 'GET',
          url: props.url,
        }),
      enabled: !!props.url,
      refetchOnWindowFocus: false,
    }),
};
